export const ALLOWED_ORIGINS = [
    "https://app.nextlayer.tech",
    "chrome-extension://EXTENSION_ID_PLACEHOLDER",
];
export function validateOrigin(origin) {
    return ALLOWED_ORIGINS.includes(origin);
}
